import 'slick-carousel/slick/slick.css';
import './style.scss';

import React from 'react';
import Slider from 'react-slick'

function PrevArrow({ className, onClick, compact }) {
  const customClass = className +
    ' carousel__arrow carousel__arrow--left' +
    (compact ? ' carousel__arrow--compact' : '')
  return (
    <div className={customClass} onClick={onClick}>
      <div className="icon-arrow-left" />
    </div>
  )
}

function NextArrow({ className, onClick, compact }) {
  const customClass = className +
    ' carousel__arrow carousel__arrow--right' +
    (compact ? ' carousel__arrow--compact' : '')
  return (
    <div className={customClass} onClick={onClick}>
      <div className="icon-arrow-right" />
    </div>
  )
}

class Carousel extends React.Component {
  componentDidMount() {
    this.resize();
  }

  componentWillReceiveProps(nextProps) {
    const keys = (this.props.children || []).map(c => c.key)
    const nextKeys = (nextProps.children || []).map(c => c.key)
    if (keys.join() !== nextKeys.join()) {
      this.reset();
      this.resize();
    }
  }

  resize() {
    /* https://github.com/akiran/react-slick/issues/809 */
    /* https://github.com/akiran/react-slick/issues/254 */
    if (this.slick.innerSlider &&
      typeof this.slick.innerSlider.onWindowResized === 'function') {
        this.slick.innerSlider.onWindowResized()
    }
  }

  reset () {
    if (this.slick &&
      typeof this.slick.slickGoTo === 'function') {
        this.slick.slickGoTo(0);
    }
  }

  render() {
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      swipe: false,
      lazyLoad: this.props.lazyLoad,
      slidesToShow: this.props.slidesToShow,
      slidesToScroll: this.props.slidesToScroll,
      responsive: this.props.responsive,
      prevArrow: <PrevArrow compact={this.props.compact} />,
      nextArrow: <NextArrow compact={this.props.compact} />,
      className: 'carousel' + (this.props.className ? ` ${this.props.className}` : '')
    }

    return (
      <Slider {...settings} ref={div => this.slick = div}>
        {this.props.children}
      </Slider>
    )
  }
}

Carousel.defaultProps = {
  lazyLoad: true,
  slidesToShow: 5,
  slidesToScroll: 5,
  responsive: [
    { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2 } }
  ]
}

export default Carousel;



// WEBPACK FOOTER //
// ./shared/components/ui/carousel/index.js